import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button.tsx';
import { Settings } from 'lucide-react';
import { NotificationHeaderMoreSettingsPopover } from '@/features/notifications/components/notification-header-more-settings-popover.tsx';

export const NotificationHeader = () => {
  const { t } = useTranslation();

  return (
    <div className="border-b border-gray-100 px-4 py-3 dark:border-gray-800">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
          {t('notifications.title')}
        </h2>
        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            size="sm"
            className="h-8 w-8 rounded-full p-0 hover:bg-gray-100 dark:hover:bg-gray-800"
          >
            <Settings className="h-4 w-4 text-gray-500" />
          </Button>
          <NotificationHeaderMoreSettingsPopover />
        </div>
      </div>
    </div>
  );
};
